import React, { Component } from 'react';
import './EmplSetting.css';
import Loader from '../../../components/Loader/Loader';
import { Util } from '../../../config/Util';
import ToastComp from '../../../components/Toast/Toast';
import axios from 'axios';
import { API } from '../../../config/API';
import toast from 'react-hot-toast';

export default class EmplSetting extends Component {
    constructor() {
        super();
        this.state = {
            loader: false,
            oldP: '',
            newP: '',
            confP: '',
            resetFlag: false,
            errorAlert: false
        }
    }

    resetForm = () => {
        this.setState({
            oldP: '',
            newP: '',
            confP: ''
        });
    }

    changePassword = () => {
        //compare new and confirm
        if (this.state.newP !== this.state.confP) {
            this.setState({ error: true });
        }
        else {
            this.setState({ error: false });
            this.setState({ loader: true });
            let user = Util.getFromSession("userData");
            const req = {
                currentPassword: this.state.oldP,
                newPassword: this.state.newP,
                id: user.id
            };
            axios.post(API.passwordreset, req).then((res) => {
                if (res && res.data && res.data.status === 'S') {
                    // this.setState({ resetFlag: true });
                    toast.success('Password changed successfully.');
                } else {
                    // this.setState({ errorAlert: true });
                    toast.error('Failed to change password!');
                }
            }).catch((er) => {
                // this.setState({ errorAlert: true });
                toast.error('An error occurred!');
            }).finally(() => {
                this.resetForm();
                this.setState({ loader: false });

            })
        }

    }

    render() {
        return (
            <div>
                <Loader loading={this.state.loader}></Loader>
                {this.state.resetFlag ? <ToastComp case='pwd-reset' handler={() => { this.setState({ resetFlag: false }) }} /> : ""}
                {this.state.errorAlert ? <ToastComp case='error' handler={() => { this.setState({ errorAlert: false }) }} /> : ""}
                <div className='bread-crumb overflow-auto'>
                    <div>
                        <span className='breadcrumb-title'>
                            <input type='button' className='btn' value='Home - Settings'></input>
                        </span>

                    </div>
                </div>
                <div className='data-table-holder'>

                    <div className='change-pwd-wrapper container'>
                        <form>
                            <div className="form-group row mt-3">
                                <label for="inputPassword" className="col-sm-2 col-form-label">Old Password</label>
                                <div className="col-sm-6">
                                    <input type="password" className="form-control" value={this.state.oldP} onChange={(e) => this.setState({ oldP: e.target.value })} placeholder="Password" />
                                </div>
                            </div>
                            <div className="form-group row mt-3">
                                <label for="inputPassword" className="col-sm-2 col-form-label">New Password</label>
                                <div className="col-sm-6">
                                    <input type="password" className="form-control" value={this.state.newP} onChange={(e) => this.setState({ newP: e.target.value })} placeholder="New Password" />
                                </div>
                            </div>
                            <div className="form-group row mt-3">
                                <label for="inputPassword" className="col-sm-2 col-form-label">Confirm Password</label>
                                <div className="col-sm-6">
                                    <input type="password" className="form-control" value={this.state.confP} onChange={(e) => this.setState({ confP: e.target.value })} placeholder="Confirm Password" />
                                </div>
                            </div>
                            {this.state.error ? <p className='error-text'>Please enter same password in new password and confirm password.</p> : ''}
                            <div className='mt-3 mb-3'>
                                <input type='button' className='btn btn-warning' value='CANCEL' onClick={this.resetForm} />
                                <input type='button' className='btn btn-success ms-3' value='PROCEED' onClick={this.changePassword} />
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        )
    }
}
